import {
  Control,
  Controller,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import {
  CreateProductFormSchemaType,
  LANG_LIST,
  useCollectionSelectOptions,
  useGenerateDetailTitle,
} from '../common';
import { FormLabel } from '../form-label';
import i18n from 'i18n';
import LOCALS from 'commons/locals';
import { Checkbox } from 'antd';

const HSS_SUFFIX = ' HSS';

const ProductCollections = ({
  control,
  setValue,
}: {
  control: Control<CreateProductFormSchemaType>;
  setValue: UseFormSetValue<CreateProductFormSchemaType>;
}) => {
  const { collectionSelectOptions } = useCollectionSelectOptions(control);
  const { generateDetailTitle } = useGenerateDetailTitle(control);

  const nameValue = useWatch({
    control,
    name: 'name',
  });

  return (
    <div className="flex items-center gap-2">
      <FormLabel className="basis-[12.5%]">
        {i18n.t(LOCALS.collections)}:
      </FormLabel>
      {collectionSelectOptions.length ? (
        <Controller
          name="collections"
          control={control}
          render={({ field }) => (
            <Checkbox.Group
              {...field}
              onChange={(value) => {
                field.onChange(value);

                const nextName = { ...nameValue };
                if (value.includes('Special Order')) {
                  LANG_LIST.forEach((lang) => {
                    if (!nextName[lang].endsWith(HSS_SUFFIX)) {
                      nextName[lang] = `${nextName[lang]}${HSS_SUFFIX}`;
                    }
                  });
                } else {
                  LANG_LIST.forEach((lang) => {
                    if (nextName[lang].endsWith(HSS_SUFFIX)) {
                      nextName[lang] = nextName[lang].slice(
                        0,
                        -HSS_SUFFIX.length,
                      );
                    }
                  });
                }
                setValue('name', nextName);

                const detailTitle = generateDetailTitle({
                  collections: value.map((d) => d.toString()),
                  name: nextName,
                });
                setValue('detailTitle', detailTitle);
              }}
            >
              {collectionSelectOptions.map(({ value, label }) => {
                return (
                  <Checkbox value={value} key={value}>
                    {label}
                  </Checkbox>
                );
              })}
            </Checkbox.Group>
          )}
        />
      ) : (
        <div className="text-gray-400">
          {i18n.t(LOCALS.please_select_category_first)}
        </div>
      )}
    </div>
  );
};

export default ProductCollections;
